// src/ResetPasswordPage.js
import React, { useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5050";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function ResetPasswordPage() {
  const q = useQuery();
  const nav = useNavigate();

  const token = q.get("token") || "";

  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setMsg("");

    if (!token) {
      setMsg("Missing token. Please use the reset link again.");
      return;
    }
    if (p1.length < 8) {
      setMsg("Password must be at least 8 characters.");
      return;
    }
    if (p1 !== p2) {
      setMsg("Passwords do not match.");
      return;
    }

    setBusy(true);
    try {
      await axios.post(`${API_BASE}/api/auth/reset-password`, {
        token,
        password: p1,
      });
      setMsg("Password updated ✅ Redirecting to login...");
      setTimeout(() => nav("/welcome"), 900);
    } catch (err) {
      setMsg(err?.response?.data?.error || "Reset failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background: "linear-gradient(135deg, #020617, #000)",
      }}
    >
      <div
        style={{
          width: "min(520px, 100%)",
          borderRadius: 22,
          border: "1px solid rgba(148,163,184,0.25)",
          background: "rgba(2,6,23,0.78)",
          boxShadow: "0 18px 45px rgba(15, 23, 42, 0.65)",
          padding: 20,
        }}
      >
        <h2 style={{ marginTop: 0 }}>Set a new password</h2>

        <form onSubmit={submit}>
          <label style={{ fontSize: 12, color: "#9ca3af" }}>New password</label>
          <input
            value={p1}
            onChange={(e) => setP1(e.target.value)}
            type="password"
            required
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 12,
              border: "1px solid rgba(75,85,99,0.7)",
              background: "rgba(15,23,42,0.85)",
              color: "#e5e7eb",
              outline: "none",
            }}
          />

          <div style={{ height: 10 }} />

          <label style={{ fontSize: 12, color: "#9ca3af" }}>Confirm password</label>
          <input
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            type="password"
            required
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 12,
              border: "1px solid rgba(75,85,99,0.7)",
              background: "rgba(15,23,42,0.85)",
              color: "#e5e7eb",
              outline: "none",
            }}
          />

          <div style={{ height: 14 }} />

          <button
            type="submit"
            disabled={busy}
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: 999,
              border: "none",
              cursor: "pointer",
              fontWeight: 800,
              textTransform: "uppercase",
              background: "radial-gradient(circle at top left, #22c55e, #16a34a)",
              color: "#022c22",
              boxShadow: "0 12px 30px rgba(34, 197, 94, 0.55)",
            }}
          >
            {busy ? "Updating..." : "Update password"}
          </button>

          {msg && <p style={{ marginTop: 12, color: "#93c5fd", fontSize: 13 }}>{msg}</p>}
        </form>
      </div>
    </div>
  );
}
